import { InjectionToken } from '@angular/core';

/** Base URL of the Techspert Freshdesk instance, e.g. https://techspert-support.freshdesk.com
 * — provided app-wide from environment.freshdeskBaseUrl, same pattern as SALESFORCE_URL. */
export const FRESHDESK_URL = new InjectionToken<string>('FRESHDESK_URL');
